import * as React from 'react';
import { forwardRef } from 'react';

export type DMSelectProps = React.SelectHTMLAttributes<HTMLSelectElement>;

export const DMSelect = forwardRef<HTMLSelectElement, DMSelectProps>(
  ({ className = '', children, ...props }, ref) => {
    return (
      <select ref={ref} className={className} {...props}>
        {children}
      </select>
    );
  }
);
DMSelect.displayName = 'DMSelect';
